$(document).ready(function(){
    // for large device
    $('#main-menu').children().eq(1).attr( 'id', 'shop_items' );
    $('#shop_items a').append('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>');

    $('#shop_items').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        $('.mega-menu').toggleClass('menu-show');
    });
    $(document).on('click', function (e) {
        var opened = $('.mega-menu').hasClass('menu-show');
        if (opened === true) {
            $('.mega-menu').removeClass('menu-show');
            
        }
    });

    // for mobile 
    $('#mobile-menu').children().eq(1).attr( 'id', 'shop_menu' );
    $('#shop_menu a').append('<div class="shop-icon"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg></div>');

    $('#shop_menu').on('click', function(event){        
        event.preventDefault();
        event.stopPropagation();
        $('.mega-menu').toggleClass('menu-show');
    });

})